import { render, staticRenderFns } from "./AddPlain.vue?vue&type=template&id=797377aa&scoped=true"
import script from "./AddPlain.vue?vue&type=script&lang=js"
export * from "./AddPlain.vue?vue&type=script&lang=js"
import style0 from "./AddPlain.vue?vue&type=style&index=0&id=797377aa&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797377aa",
  null
  
)

export default component.exports